import React from 'react';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';
import styles from './info-tooltip.module.scss';
import { classNames } from 'tradera/utils/class-names';

type InfoTooltipProps = React.PropsWithChildren<{
    customIcon?: React.ReactNode;
    className?: string;
    containerClassName?: string;
    iconSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    showAbove?: boolean;
}>;

export const InfoTooltip = ({
    customIcon,
    className,
    containerClassName = '',
    children,
    iconSize = 'md',
    showAbove = false
}: InfoTooltipProps) => (
    // TODO: should probably use Tooltip and wrap the InfoIcon
    <span
        className={classNames(
            styles.container,
            showAbove && styles.showAbove,
            containerClassName
        )}>
        <span className={styles.target}>
            {customIcon || (
                <InfoIcon
                    className={classNames(`icon icon-${iconSize}`, className)}
                />
            )}
            <span className={styles.arrow} />
        </span>
        <span className={styles.tooltip}>{children}</span>
    </span>
);
